export default {
  'memberSuspension.notice.title': 'พื้นที่สมาชิก',
  'memberSuspension.notice.heading': 'ฟีเจอร์สมาชิกถูกระงับชั่วคราว',
  'memberSuspension.notice.description':
    'ฟีเจอร์สมาชิกของคุณถูกระงับการใช้งานอยู่ในขณะนี้',
  'memberSuspension.notice.contact': 'หากมีข้อสงสัย กรุณาติดต่อพนักงานหน้าร้าน',
  'memberSuspension.notice.provider': 'ให้บริการโดย Echoss VIP',
  'memberSuspension.register.blocked': 'ไม่สามารถลงทะเบียนได้ กรุณาติดต่อหน้าร้าน',
  'memberSuspension.login.blocked': 'ไม่สามารถเข้าสู่ระบบได้ กรุณาติดต่อหน้าร้าน',
  'memberSuspension.asset.blocked':
    'สมาชิกภาพนี้ถูกระงับ จึงไม่สามารถใช้สิทธิพิเศษหรือคูปองได้',
  'memberSuspension.feature.blocked': 'สมาชิกนี้ถูกระงับและไม่สามารถใช้ฟังก์ชันนี้ได้',
} as Record<string, string>;
